import React from "react";
import styled from "styled-components";
import { ChromePicker } from "react-color";

const PickerWrapper = styled.div`
    position: relative;
`;

const ColorPicker = ({ color, onChange }) => {
    const rgbaString = ({ r, g, b, a }) => `rgba(${r}, ${g}, ${b}, ${a})`;

    return (
        <PickerWrapper onMouseDown={(e) => e.stopPropagation()}>
            <ChromePicker 
                color={color} 
                onChange={(updatedColor) => {
                    onChange("color", rgbaString(updatedColor.rgb));  
                }} 
            />
        </PickerWrapper>
    );
};

export default ColorPicker;
